import _ from 'lodash';

export default function showDetailProgram(referral) {
  return !_.isEmpty(referral.referred_to_program);
}
